// feel free to change
export const SITE_TITLE: string = "Toy Gallery";

export const NON_MOBILE_WIDTH: number = 768;
export const NON_MOBILE_HEIGHT: number = 480;
export const LAPTOP_WIDTH: number = 1024;
export const LAPTOP_HEIGHT: number = 550;
